<template>
  <div class="judge_question">
    <div class="question_title">
      <span>{{questionData.sectionName === undefined ? "" : questionData.sectionName}}</span>
      <span>({{questionData.sectionPrompt+"  本题"+questionData.score+"分。"}})</span>
    </div>
    <div class="title">
      <div v-if="questionData.questionContent" class=" editorShowArea ql-editor title_one" v-html="questionData.questionContent"></div>
      <h3 style="overflow: auto;" class=" editorShowArea ql-editor" v-html="questionData.questionDto.questionContent"></h3>
    </div>
    <div class="select">
      <i @click="select(0)" :class="{active:num === 0}" class="el-icon-circle-check"></i>
      <i @click="select(1)" :class="{active:num === 1}" style="margin-left:60px;" class="el-icon-circle-close"></i>
    </div>

  </div>
</template>

<script>
    import {moduleId} from "../../../../../store/modules/exam";
    import {mapState, mapMutations, mapActions, mapGetters} from 'vuex';
    export default {
        name: "judge",
        data(){
            return {
                num:''
            };
        },
        computed:{
            ...mapState(moduleId, {
                questionData: state => state.questionData,
                paperData: state => state.paperData,
                preAnswer: state => state.preAnswer,
            }),
        },
        watch:{
            preAnswer(newVal){
               console.log(newVal);
                if(newVal !== null){
                    if(newVal.answer === '正确'){
                        this.num = 0;
                    }else if (newVal.answer === '错误'){
                        this.num = 1;
                    }else{
                      this.num = '';
                  }

                }

            }
        },
        created(){
          console.log(444)
        }
        ,
        methods:{
            ...mapActions(moduleId,['saveAnswer']),
            select(val){
                let str ='';
               this.num = val;
                if(val == 0){
                    str = '正确'
                }else if(val == 1){
                    str = '错误'
                }
                let obj = {
                  "examPaperId":this.paperData.examPaperId,
                  "subjectId":localStorage.getItem("subjectId"),
                  "classId":this.$route.query.classId,
                  "courseId":this.$route.query.id,
                  "paperCode":this.$route.query.paperCode,
                  "paperId":this.$route.query.paperId,
                  "questionId":this.questionData.questionId,
                  "questionType":3,
                  "version":1,
                  "userAnswer":str,
                  "score":this.questionData.score,
                  "questionStatus":0,
                  "useTime":"23",
                  "type":this.$route.query.type
                };
                this.saveAnswer(obj);
                console.log('保存了')
            },

        }
    }
</script>

<style lang="scss" scoped>
  .judge_question {
    background: white;
    height: 100%;
    .question_title{
      margin-left: 30px;
      padding-top:30px;
      span:nth-child(1){
        font-size:18px;
        font-weight: bold;
      }
      span:nth-child(2){
        font-size:12px;
        font-weight: 500;
        margin-left: 12px;
      }
    }
    .title{
      .title_one{
        border-bottom: 1px dashed black;
        width: 95%;
        margin:auto;
      }
      .ql-editor{
        max-width: 95%;
        overflow: auto!important;
        margin:auto;
      }
      /deep/ .ql-editor img{
        max-width: 100% !important;
      }
    }
    .select{
        margin-top:70px;
      text-align: center;
        i{
          font-size: 50px;
          cursor: pointer;
          &:hover{
            color:#5397F7;
          }
        }
      .active{
        color:#5397F7;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/views/studyCenter/switch/testComponent/judge.vue